import { memo, forwardRef } from 'react';
import { compose } from 'recompose';

export const withMemoAndRef = Component => compose(memo, forwardRef)(Component);
